module.exports = __webpack_public_path__ + "static/media/ExploringBadge.64eaadfe.svg";